import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { StockChart, ChartModule } from 'angular-highcharts';
import * as Highcharts from 'highcharts';
import { numberFormat } from 'highcharts/highcharts.src';

interface ChartData {
    timestamp: string;
    peso_prodotto: number;
    volume_prodotto: number;
    idSessione: number;
    ordine_griglia: number;
    rating?: number;
}

@Component({
    selector: 'app-chart',
    templateUrl: './chart.component.html',
    styleUrls: ['./chart.component.scss'],
    imports: [ChartModule]
})
export class ChartComponent implements OnInit, OnChanges {

    @Input() data: ChartData[];

    yAxisOptions: Highcharts.YAxisOptions | Highcharts.YAxisOptions[] = [
        {
            title: {
                text: 'Peso stimato',
            }
        },
        {
            title: {
                textAlign: "center",
                align: "middle",
                text: 'Volume vuoto misurato',
            },
            opposite: false,
        },
    ]

    computedData = [];

    seriesOptions: Highcharts.SeriesOptionsType[];
    stock: StockChart;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['data']?.currentValue) {
            this.computedData = changes['data'].currentValue
                .map((el: ChartData) => ({
                    x: Number(el.timestamp),
                    y: el.peso_prodotto,
                    peso: el.peso_prodotto,
                    volume_prodotto: el.volume_prodotto,
                    idSessione: el.idSessione,
                    ordineGriglia: el.ordine_griglia,
                    rating: el.rating ?? null
                }))
                .filter((point) => Number.isFinite(point.x))
                .sort((a, b) => a.x - b.x);
            this.initChart();
        }
    }

    ngOnInit(): void {
        this.initChart();
    }

    initChart(): void {
        this.stock = new StockChart({
            time: {
                useUTC: false
            },
            title: {
                text: 'TREND PESI'
            },
            accessibility: {
                enabled: false
            },
            rangeSelector: {
                selected: 0
            },
            tooltip: {
                useHTML: true,

                formatter: function () {
                    const dateValue = new Date(this.x as number);
                    const twoDigit = (value: number) => value.toString().padStart(2, '0');
                    const date = `${twoDigit(dateValue.getDate())}/${twoDigit(dateValue.getMonth() + 1)}/${twoDigit(dateValue.getFullYear() % 100)} ${twoDigit(dateValue.getHours())}:${twoDigit(dateValue.getMinutes())}`;
                    let tooltip = date;
                    this.points.forEach(function (point) {
                        return tooltip += `
                        <br>Peso: ${numberFormat(point.point['peso'] / 1000, 2)} t
                        <br>Volume: ${numberFormat(point.point['volume_prodotto'], 1.1)}
                        <br>IdSessione: ${point.point['idSessione']}
                        <br>Ordine griglia: ${point.point['ordineGriglia']}
                        <br>Rating misura: ${point.point['rating'] !== null && point.point['rating'] !== undefined ? Math.round(point.point['rating']) : '-'}
                        </div>`;
                    })
                    return tooltip;
                }
            },
            yAxis: this.yAxisOptions,
            series: [
                {
                    type: 'line',
                    data: this.computedData,
                }
            ]
        });
    }

}
